import { render, staticRenderFns } from "./activityTopicFeedbackAction.html?vue&type=template&id=dc77abca&external"
import script from "./activityTopicFeedbackAction.vue?vue&type=script&lang=js"
export * from "./activityTopicFeedbackAction.vue?vue&type=script&lang=js"
import style0 from "./activityTopicFeedbackAction.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports